export default __webpack_public_path__ + "static/media/hht2_storybook_19.648a641c.png";